import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { SurveyAuthService } from '../../../../shared/survey-auth.service';

@Injectable()
export class SurveyResultsService {
  constructor(private http: HttpClient, private auth: SurveyAuthService) {}

  getSurveyStatistics(id: number): Observable<Object> {
    console.log('SurveyResultsService.getSurveyStatistics invoked for id', id);

    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);
    const surveyStatisticsUrl = `${
      environment.surveyApiHost
    }/api/v1/survey_statistics/${id}`;

    return this.http
      .get(surveyStatisticsUrl, { headers: headers })
      .map(this.processResponse)
      .catch(this.handleError);
  }

  processResponse(response: HttpResponse<any>) {
    console.log('response.json:', response);
    return response;
  }

  getSurveyReportData(id: number, lang: string): Observable<Object> {
    console.log('SurveyResultsService.getSurveyReportData invoked for id', id);

    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);
    let surveyReportStatisticsUrl = `${
      environment.surveyApiHost
    }/api/v1/survey_report/${id}/`;
    // if (page != null)
    //  surveyReportStatisticsUrl = surveyReportStatisticsUrl + `${page}/`;
    if (lang != null)
      surveyReportStatisticsUrl = surveyReportStatisticsUrl + `?lang=${lang}`;

    console.log('surveyReportStatisticsUrl: ', surveyReportStatisticsUrl);
    return this.http
      .get(surveyReportStatisticsUrl, { headers: headers })
      .map(this.processResponse)
      .catch(this.handleError);
  }

  private handleError(error: HttpResponse<any> | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof HttpResponse) {
      const body = error.body.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}
